import { Box, Typography } from "@mui/material";

const GitLabAccessTokenDetailsView = ({ entityData }) => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {entityData?.gitlab_access_token_data && (
        <>
          <Box display="flex" flexDirection="column" gap={1}>
            <Box display="flex" alignItems="center" gap={1}>
              <Typography variant="subtitle2">Revoked</Typography>
            </Box>
            <Box ml={3} display="flex">
              <Typography variant="caption">
                {entityData.gitlab_access_token_data.revoked ? "Yes" : "No"}
              </Typography>
            </Box>
          </Box>
          {entityData.gitlab_access_token_data.scopes && (
            <Box display="flex" flexDirection="column" gap={1}>
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="subtitle2">Scopes</Typography>
              </Box>
              <Box ml={3} display="flex" flexDirection="column" gap={1}>
                {entityData.gitlab_access_token_data.scopes.map((scope) => (
                  <Typography key={scope} variant="caption">
                    {scope}
                  </Typography>
                ))}
              </Box>
            </Box>
          )}
          {entityData.gitlab_access_token_data.group_name && (
            <Box display="flex" flexDirection="column" gap={1}>
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="subtitle2">Group</Typography>
              </Box>
              <Box ml={3} display="flex">
                <Typography variant="caption">
                  {entityData.gitlab_access_token_data.group_name}
                </Typography>
              </Box>
            </Box>
          )}
          {entityData.gitlab_access_token_data.project_name && (
            <Box display="flex" flexDirection="column" gap={1}>
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="subtitle2">Project</Typography>
              </Box>
              <Box ml={3} display="flex">
                <Typography variant="caption">
                  {entityData.gitlab_access_token_data.project_name}
                </Typography>
              </Box>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default GitLabAccessTokenDetailsView;
